export const mapNotifyConfigToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const notifyConfigColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "attrCode", label: "Attr Code", align: "center" },
  { key: "content", label: "Content", align: "center" },
  { key: "valueType", label: "Value Type", align: "center" },
  { key: "value", label: "Value", align: "center" },
  { key: "delay", label: "Delay time", align: "center" },
  { key: "displayTime", label: "Display time", align: "center" },
];
